import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react"

export const getPartner = () => {
    try {
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href)
            return url.searchParams.get('p') || localStorage.getItem('p')
        }

        return undefined
    } catch (_e) {
        return undefined
    }
}

export const storePartner = (partner: string) => {
    localStorage.setItem('p', partner)
    // Also store in cookie for server-side access (30 days expiry)
    document.cookie = `partner_code=${partner}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`
}

export const checkIfSiteimpact = () => {
    return getPartner() === 'siteimpact'
}

/**
 * Server-side: Extract partner code from cookie
 */
export const getPartnerCodeFromCookies = (cookieHeader: string | undefined): string | null => {
    if (!cookieHeader) return null
    const match = cookieHeader.match(/(?:^|;\s*)partner_code=([^;]*)/)
    return match ? decodeURIComponent(match[1]) : null
}


const PartnerContext = createContext<{ partner: string } | null>(null)

export const usePartner = () => {
    const context = useContext(PartnerContext)
    if (!context) throw new Error('PartnerProvider not found in root')
    return context
}

export const useIsSiteimpact = () => {
    const { partner } = usePartner()
    if (typeof partner === 'string') {
        return { isSiteimpact: partner === 'siteimpact' }
    }
    return { isSiteimpact: undefined }
}

export const PartnerProvider = ({ children }: PropsWithChildren) => {
    const [partner, setPartner] = useState<string>()
    
    useEffect(() => {
        const p = getPartner()
        // eslint-disable-next-line react-hooks/set-state-in-effect -- syncs partner code from browser-only sources (URL query + localStorage) into state on mount; a lazy initializer would read undefined on the server and cause an SSR hydration mismatch
        setPartner(typeof p === 'string' ? p : '')
        if (typeof p === 'string') storePartner(p)
    }, [])

    return <PartnerContext.Provider value={{ partner }}>
        {children}
    </PartnerContext.Provider>
}